import { z } from 'zod'

import { LoginInput } from '../../../common/validations'

export const formatFormValues = (formValues: LoginInput) => {
  return {
    username: formValues.username,
    password: formValues.password,
  } as LoginInput
}

export const validateEmail = (email: string) => {
  const emailValidation = z.string().email().safeParse(urlDecode(email))
  if (emailValidation.success) {
    return emailValidation.data
  }
  return null
}

export const urlDecode = (url: string) => {
  try {
    return decodeURI(url)
  } catch (e) {
    return null
  }
}
